import { createContext, useContext } from 'react';

import type { ButtonProps } from './Button';

export interface ButtonGroupContextValue {
  size?: ButtonProps['size'];
  variant?: ButtonProps['variant'];
  color?: ButtonProps['color'];
  disabled?: boolean;
}

const ButtonGroupContext = createContext<ButtonGroupContextValue | null>(null);

export const ButtonGroupProvider = ButtonGroupContext.Provider;

export const useButtonGroup = (): ButtonGroupContextValue | null =>
  useContext(ButtonGroupContext);
